
export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <img
              src="/Logo_Cashflow_VIP.svg"
              alt="CashFlow VIP"
              className="h-28 w-auto mb-4"
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Transformamos tu situación financiera con estrategias exclusivas de reestructuración de crédito y acceso a capital sin intereses.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://wa.me/13056840894"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-7 text-white p-3 rounded-full transition-colors duration-300"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/fiormartecpa/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white p-3 rounded-full transition-all duration-300"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="tel:+13056840894"
                className="bg-gray-700 hover:bg-gray-600 text-white p-3 rounded-full transition-colors duration-300"
              >
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li><a href="/servicios/creacion-corporaciones" className="text-gray-400 hover:text-vip-gold transition-colors">Creación de Corporaciones</a></li>
              <li><a href="/servicios/reparacion-credito" className="text-gray-400 hover:text-vip-gold transition-colors">Reparación de Crédito</a></li>
              <li><a href="/servicios/obtencion-funding" className="text-gray-400 hover:text-vip-gold transition-colors">Obtención de Funding</a></li>
              <li><a href="/servicios/mentorias-personalizadas" className="text-gray-400 hover:text-vip-gold transition-colors">Mentorías Personalizadas</a></li>
              <li><a href="/servicios" className="text-gray-400 hover:text-vip-gold transition-colors">Ver Todos</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-vip-gold"></i>
                <a href="tel:+13056840894" className="text-gray-300 hover:text-vip-gold transition-colors duration-300">
                  +1 (305) 684-0894
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-vip-gold"></i>
                <a href="https://wa.me/13056840894" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-vip-gold transition-colors duration-300">
                  WhatsApp
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-instagram-line text-vip-gold"></i>
                <a href="https://www.instagram.com/fiormartecpa/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-vip-gold transition-colors duration-300">
                  @fiormartecpa
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-vip-gold"></i>
                <a href="https://maps.app.goo.gl/ZRCHD4nJWTyodNz76" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-vip-gold transition-colors duration-300">
                  Miami, FL
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 CashFlow VIP. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/legal/terminos" className="text-gray-400 hover:text-vip-gold text-sm transition-colors duration-300">
              Términos de Servicio
            </a>
            <a href="/legal/privacidad" className="text-gray-400 hover:text-vip-gold text-sm transition-colors duration-300">
              Política de Privacidad
            </a>
            <a href="/legal/cookies" className="text-gray-400 hover:text-vip-gold text-sm transition-colors duration-300">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
